/*
 * @Author: w
 * @Date: 2022-03-30 17:23:58
 * @LastEditors: xuqiang@mingxinsk.com
 * @LastEditTime: 2024-01-29 11:37:46
 */
export function isEmptyValue(v:any) {
  return v == null || v === "";
}


export function downLink(fileUrl:string, filename:string) {
  const link = document.createElement("a");
  document.body.appendChild(link);
  link.href = fileUrl
  link.download = filename;
  link.click();
  setTimeout(function() {
    document.body.removeChild(link);
  }, 50);
}

// 金额格式化为：千分位，小数位，非数字,price为金额，n为小数点后几位
export function fmoney (price:any, n:number) {
  if (isNaN(parseFloat(price))) {
    return ''
  }
  n = n > 0 && n <= 20 ? n : 2
  price = parseFloat((price + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
  var l = price
    .split('.')[0]
    .split('')
    .reverse()
  var r = price.split('.')[1]
  let t = ''
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? ',' : '')
  }
  return (
    t
      .split('')
      .reverse()
      .join('') +
    '.' +
    r
  )
}

const _toString = Object.prototype.toString

function isType (type:string) {
  return function (o:any) {
    return _toString.call(o) === '[object ' + type + ']'
  }
}

export function dateFormat(value:any, format:string) {
  let date = new Date(value);
  let o:any = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp(`(${k})`).test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return format;
}

export function dateFormatNormal(date:any){
  return dateFormat(date,"yyyy-MM-dd hh:mm:ss")
}
export function dateFormatMM(date:any){
  return dateFormat(date,"yyyy-MM-dd hh:mm")
}
export function dateFormatDay(date:any){
  return dateFormat(date,"yyyy-MM-dd")
}
export function dateFormatMd(date:any){
  return dateFormat(date,"MM-dd hh:mm")
}
export function timestampToTime(timestamp:any) {
  if(timestamp===0||timestamp===null) return ''
  let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  // let Y = date.getFullYear() + '-';
  let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '月';
  let D = date.getDate() + ' ';
  let h = date.getHours() + ':';
  let m = date.getMinutes() ;
  // let s = date.getSeconds();
  return M+D+h+m;
}

// 判断是不是数组
export const isArray = Array.isArray || isType('Array')
export const isObject = isType('Object')
export const isDate = isType('Date')


// json 数据改为 formData
export function convertToFormData(data: any) {
  const params = new URLSearchParams();
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      params.append(key, data[key]);
    }
  }
  return params.toString();
}
/**
  * 解析流文件并下载
  * @param res 下载文件请求结果
  * @param type 文件下载类型
 * */ 
export function exportFile (res: any, type: any) {
  // 创建blob对象，解析流数据
  const blob = new Blob([res.data], { type })
  const a = document.createElement('a')
  const URL = window.URL || window.webkitURL
  const herf = URL.createObjectURL(blob)
  a.href = herf
  a.download = res.filename || '未命名文件'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(herf)
}
export function formatJsonToUrlParams(data: any) {
  return typeof data === 'object'
    ? Object.keys(data)
        .map((key) => {
          return `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        })
        .join('&')
    : ''
}

//生成当前时间
export function getCurrentDateTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
/**
  * 根据date年月日格式化
  * @param dateTime date时间
 * */ 
export function formatDateTime(dateTime: Date): string {
  const padZero = (num: number): string => {
    return num.toString().padStart(2, '0')
  }
  const year = dateTime.getFullYear()
  const month = padZero(dateTime.getMonth() + 1)
  const day = padZero(dateTime.getDate())
  const hours = padZero(dateTime.getHours())
  const minutes = padZero(dateTime.getMinutes())
  const seconds = padZero(dateTime.getSeconds())
  return `${year}年 ${month}月${day}日 ${hours}:${minutes}:${seconds}`
}
/**
  * 生成 yyyy-mm-dd hh:mm:ss时间格式
  * @param dateTime date时间 不传入则默认当前时间
 * */
 export function getFormattedTime(dateTime: Date) {
  const targetDate = dateTime ? new Date(dateTime) : new Date()
  const year = targetDate.getFullYear()
  const month = String(targetDate.getMonth() + 1).padStart(2, '0')
  const day = String(targetDate.getDate()).padStart(2, '0')
  const hours = String(targetDate.getHours()).padStart(2, '0')
  const minutes = String(targetDate.getMinutes()).padStart(2, '0')
  const seconds = String(targetDate.getSeconds()).padStart(2, '0')
  const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  return formattedTime
}